import React from "react"
import {Box, Chip} from "@mui/material"

import type {IdentificationHint} from "../types"

function hintColor(kind: IdentificationHint["kind"]): "default" | "primary" | "warning" {
	if (kind === "junk" || kind === "third-party") return "warning"
	if (kind === "candidate" || kind === "rule" || kind === "content-match") return "primary"
	return "default"
}

function HintChips({hints}: {hints: IdentificationHint[]}) {
	if (hints.length === 0) return null

	return (
		<Box display="flex" gap={0.75} flexWrap="wrap">
			{hints.map((hint) => (
				<Chip
					key={`${hint.kind}:${hint.label}`}
					label={hint.label}
					title={hint.evidence}
					size="small"
					color={hintColor(hint.kind)}
					variant="outlined"
				/>
			))}
		</Box>
	)
}

export {HintChips}
